app.controller("LecturerIndexController", [
    "$scope", "Students", "$uibModal", "StaticData", "$stateParams", "AuthService", "LecturerService", "$state", "usSpinnerService", "toastr",
    function ($scope, Students, $uibModal, StaticData, $stateParams, AuthService, LecturerService, $state, usSpinnerService, toastr) {
        $scope.group = null;
        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.sessionTypes = [{name: "სესიის ტიპი"}].concat(types);
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        $scope.loadPage = function () {
            AuthService.getUserData().then(function (user) {
                $scope.profile = user.profiles.filter(function (p) {
                    return p.type === "lecturer" && p.state === 'active'
                })[0];
                $scope.user = user;
                fetchSubjects($scope.profile._id);
            });
        };

        $scope.loadPage();

        function fetchSubjects(lecturerId) {
            usSpinnerService.spin("root");
            LecturerService.subjectList({lecturerId: lecturerId}).then(function (subjects) {
                $scope.subjects = subjects;
                usSpinnerService.stop("root");
            });
        }

        $scope.addMessage = function (subject, group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectName: subject.name,
                            group: group,
                            sessionType: $scope.sessionTypesMap[group.sessionType].name
                        };
                    }
                }
            }).result
                .then(function (result) {
                    toastr.success('', 'სტატუსი განახლებულია');
                    $scope.loadPage();
                }, function () {
                });
        };

        $scope.addURL = function (subject, group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            zoomUrl: true,
                            subjectName: subject.name,
                            group: group,
                            sessionType: $scope.sessionTypesMap[group.sessionType].name
                        };
                    }
                }
            }).result
                .then(function (result) {
                    toastr.success('', 'ბმული განახლებულია');
                    $scope.loadPage();
                }, function () {
                });
        };

        $scope.showMenu = function ($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
        };

        $scope.showDetails = function (subject) {
            $state.go("lecturer.grades", {subject: subject._id});
        };

        $scope.exportSyllabus = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            var name = subject.name;
            name = name.replace(/[&$%@#!?`'"|\/<>{}*+,;:^]/g, "");
            window.open(`${location.origin}/syllabuses/export/${subject._id}/${name}`);
        };

        $scope.syllabus = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("lecturer.subject-syllabus", { subjectId: subject._id, action: 'edit' });
        };

        $scope.consultations = function () {
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectName: $scope.user.firstName + ' ' + $scope.user.lastName + ' - კონსულტაციების გრაფიკი',
                            lecturerId: $scope.profile._id
                        };
                    }
                }
            }).result
                .then(function () {
                    toastr.success('', 'კონსულტაციების გრაფიკი განახლებულია');
                    setTimeout(function () {
                        $window.location.reload();
                    }, 500);
                }, function () {
                });
        }

        $scope.goToStudents = function (sessionGroup, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("lecturer.selection-details", {activationId: sessionGroup.subjectActivation});
        }
    }
]);
